import { Button, Dropdown, DropdownItem, Icon, Popover } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { Children } from 'react'
import styles from 'components/Dropdown/dropdown.module.scss'

const DropdownComponent = ({
  itemsSize = 'l',
  wrapItems = false,
  id,
  children,
  dropDownClassName = '',
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  },
  transformOrigin = {
    vertical: 'top',
    horizontal: 'right',
  },
  ButtonComponent = () => (
    <Button
      variant={'ghost'}
      noLabel
      colorHover={'Interface-GU-Primary'}
      colorActive={'Interface-GU-Primary'}
      color={'Interface-Eighth'}
      startIcon={<Icon name={'other'} />}
      size={'s'}
      className={styles['dropTriggerIcon']}
    />
  ),
}) => {
  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()

  const popupState = usePopupState({
    variant: 'popover',
    id: 'dropMenuId-' + id,
  })

  return (
    <div key={'popover-' + id}>
      <span {...bindTrigger(popupState)}>
        <ButtonComponent />
      </span>
      <Popover
        {...bindPopover(popupState)}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        <Dropdown
          className={styles.dropdownMenu}
          onClick={() => popupState.isOpen && popupState.close()}
        >
          {wrapItems
            ? Children.map(
                children,
                (child, index) =>
                  child && (
                    <DropdownItem
                      size={itemsSize}
                      key={'DropdownItem-' + index}
                      className={dropDownClassName}
                    >
                      {child}
                    </DropdownItem>
                  ),
              )
            : children}
        </Dropdown>
      </Popover>
    </div>
  )
}

DropdownComponent.propTypes = {
  wrapItems: PropTypes.bool,
  itemsSize: PropTypes.oneOf(['m', 'l']),
  id: PropTypes.string,
  dropDownClassName: PropTypes.string,
  children: PropTypes.any,
  ButtonComponent: PropTypes.func,
  anchorOrigin: PropTypes.object,
  transformOrigin: PropTypes.object,
}

export default DropdownComponent
